import React,{useState} from 'react';
import { Grid,  Card,  Zoom} from "@material-ui/core";
import NormalDireccionesCard from './NormalDireccionesCard'
import EditDireccionesCard from './EditDireccionesCard'

const MainDireccionesCards = ({direccion,destinatario,onDelete,doPatch,doPatchDestinatario,doDeleteDestinataio}) => {
      /**State para saber si esta editando */
      // console.log(direccion)
      // console.log(destinatario)
      const [Edit, setEdit] = useState(false);
      /** Handles de Edit y Delete */
      const handleDelete=()=>{
         new Promise(resolve => {
           setTimeout(() => {
             onDelete(direccion);
             resolve();
           }, 1000);
         })
         new Promise(resolve => {
          setTimeout(() => {
            doDeleteDestinataio(destinatario);
            resolve();
          }, 1000);
        })
         
      }
      const handleEditData=(newData)=>{
        const {estado,pais,cp,calle,numero,colonia,delegacion,referencia
          ,nombre,correo,telefono,empresa}=newData;
        const Destinatario={
          _id:destinatario._id,
          nombre,
          correo,
          telefono,
          empresa
        }
        const Direccion={
          _id:direccion._id,
          estado:estado.value,
          pais,
          cp,
          calle,
          numero,
          colonia,
          delegacion,
          referencia,
          destinatario:destinatario._id
        }
        new Promise(resolve => {
          setTimeout(() => {
            doPatchDestinatario(Destinatario);
            resolve();
          }, 1000);
        })
        new Promise(resolve => {
          setTimeout(() => {
            doPatch(Direccion);
            resolve();
          }, 1000);
        })
        setEdit(false)
      }
      const handleEdit=()=>{
        setEdit(true); 
      }
      const cancelEdit=()=>{
        setEdit(false)
      }
      
    return ( !Edit ? 
      <Zoom  in={true} timeout={{enter:500, exit: 500}} >
        <Grid  item xs={12} sm={6} md={4} >
        <Card >
        <NormalDireccionesCard  destinatario={destinatario} direccion={direccion} handleEdit={handleEdit} handleDelete={handleDelete} />
        </Card>
      </Grid>
      </Zoom>
    :
      <Grid   item xs={12} sm={6} md={4} >
        <Zoom in={true} timeout={{enter : 500,exit : 500}} >
      <Card>
      <EditDireccionesCard  destinatario={destinatario} direccion={direccion} cancelEdit={cancelEdit} handleEditData={handleEditData}/>
      </Card>
      </Zoom> 
      </Grid>
    
    )
}

export default MainDireccionesCards;                                                                                                                                    